import { OrderStatus } from 'ComponentLibrary/src/atoms/OrderStatus/OrderStatusIcon.stories'
import { every } from 'lodash'
import { z } from 'zod'
import { OrderStatusSchema } from './schemas.zod'

// This dummy note is a trigger for the backend to automatically set the status to temp_hide_in_portal
export const DUMMY_ORDER_NOTE = '[[DUMMY_ORDER]]'

export const OPEN_ORDER_STATUSES = [
    'open',
    'accepted',
    'in_communication_with_owner',
    'inspection_scheduled',
    'in_progress',
    'in_review',
    'on_hold',
    'blocked',
] as const

export const CLOSED_ORDER_STATUSES = ['done', 'canceled'] as const

export const ORDER_STATUSES = [...OPEN_ORDER_STATUSES, ...CLOSED_ORDER_STATUSES, 'temp_hide_in_portal'] as const

export type OrderStatus = z.infer<typeof OrderStatusSchema>

export function isInStatus(order: { status: OrderStatus }, statuses: readonly OrderStatus[]): boolean {
    return statuses.includes(order.status)
}

export function isOrderStatus(maybeOrderStatus: unknown): maybeOrderStatus is OrderStatus {
    return !!(typeof maybeOrderStatus === 'string' && ORDER_STATUSES.find((status) => status === maybeOrderStatus))
}

export function isOrderStatusList(statuses: string[]): statuses is OrderStatus[] {
    return every(statuses, isOrderStatus)
}
